import { render, staticRenderFns } from "./TablePermissions.vue?vue&type=template&id=6c5139d8&scoped=true"
import script from "./TablePermissions.vue?vue&type=script&lang=js"
export * from "./TablePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5139d8",
  null
  
)

export default component.exports